import { useAxiosClient } from '..';

export const useStateApi = () => {
    const { axiosClient } = useAxiosClient();

    return {
        stateList: async (countryId) => (await axiosClient.get(`/v1/state/${countryId}`)).data,
        cityList: async (stateId) => (await axiosClient.get(`/v1/state/${stateId}/cities`)).data,
    }
}